// External
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PATH_LOCATIONS, PATHS } from '../services/values/values.service';
import { AuthService } from '../services/auth/auth.service';

// Internal

@Injectable({ providedIn: 'root' })

export class AuthGuard {

    constructor(
        private readonly authService: AuthService,
    ) {}

    /**
    * This method verifies if user is logged in and redirects him properly
    * @param route - ActivatedRouteSnapshot
    * @param state - RouterStateSnapshot
    * @returns {Observable} Redirects to login page or returns Observable
    */
    public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean|UrlTree> {
        return new Observable<boolean|UrlTree>((subscriber) => {
            //* daca userul nu e logat si daca nu are userToken in url
            if (!this.authService.isLoggedIn()) {
                this.authService.clearLoginInfo();
                window.location.href = PATH_LOCATIONS.children[PATHS.LOGIN].path;
                subscriber.next(false);
                subscriber.complete();
            // daca userul are userToken in url si navigheaza pe pagina care necesita login
            // se face requestul pt logare
            // acest lucru impiedica buguri de genul: sunt logata cu un cont, dar daca am un link care m-ar loga cu alt cont,
            // raman blocat cu primul cont
            } else {
                subscriber.next(true);
                subscriber.complete();
            }
        });
    }

}